(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-mailerlite"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var forms = document.querySelectorAll('[data-newsletter-form]');
    if (!forms.length) return;

    // Walidacja przed wysłaniem. Bez JS działa natywna walidacja HTML
    // (required + type=email); z JS przejmujemy ją, żeby pokazać komunikat
    // po polsku i nie wysyłać do MailerLite pustego / złego adresu ani
    // zapisu bez zaznaczonej zgody.
    var EMAIL_RE = /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)*\.[^\s@.]{2,}$/;
    var MSG = {
      name: 'Podaj imię.',
      emailEmpty: 'Podaj adres e-mail.',
      emailInvalid: 'Podaj poprawny adres e-mail, np. jan@przyklad.pl.',
      consent: 'Zaznacz zgodę, aby zapisać się do newslettera.',
      server: 'Nie udało się zapisać. Sprawdź adres e-mail i spróbuj ponownie.',
    };

    forms.forEach(function (form) {
      form.noValidate = true;

      var root = form.closest('.newsletter-mailerlite');
      var success = root && root.querySelector('[data-newsletter-success]');
      var errorEl = form.querySelector('[data-newsletter-error]');
      var disabledText = errorEl ? errorEl.textContent.trim() : '';
      var nameInput = form.querySelector('input[name="fields[name]"]');
      var emailInput = form.querySelector('input[name="fields[email]"]');
      var consent = form.querySelector('input[name="consent"]');
      var submit = form.querySelector('[type="submit"]');

      function clearError() {
        if (errorEl) errorEl.hidden = true;
        [nameInput, emailInput, consent].forEach(function (el) {
          if (el) el.removeAttribute('aria-invalid');
        });
      }

      function showError(message, field) {
        if (errorEl) {
          errorEl.textContent = message;
          errorEl.hidden = false;
        }
        if (field) {
          field.setAttribute('aria-invalid', 'true');
          try { field.focus(); } catch (_) {}
        }
      }

      function showSuccess() {
        form.hidden = true;
        if (success) {
          success.hidden = false;
          try { success.focus(); } catch (_) {}
        }
      }

      form.addEventListener('input', clearError);
      form.addEventListener('change', clearError);

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        clearError();

        // Disabled state (no MailerLite URL configured yet)
        if (form.hasAttribute('data-newsletter-disabled')) {
          showError(disabledText);
          return;
        }

        var email = emailInput ? emailInput.value.trim() : '';
        if (emailInput) emailInput.value = email;

        if (nameInput && nameInput.required && !nameInput.value.trim()) {
          showError(MSG.name, nameInput);
          return;
        }
        if (!email) {
          showError(MSG.emailEmpty, emailInput);
          return;
        }
        if (!EMAIL_RE.test(email) || (emailInput.checkValidity && !emailInput.checkValidity())) {
          showError(MSG.emailInvalid, emailInput);
          return;
        }
        if (consent && !consent.checked) {
          showError(MSG.consent, consent);
          return;
        }

        if (submit) submit.disabled = true;

        fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
        })
          .then(function (response) {
            return response.json();
          })
          .then(function (data) {
            // MailerLite (endpoint jsonp) zwraca CORS + JSON: {success:false,errors:{…}}
            if (data && data.success === false) {
              if (submit) submit.disabled = false;
              showError(MSG.server, emailInput);
              return;
            }
            showSuccess();
          })
          .catch(function () {
            // Odpowiedź nieczytelna (np. sieć / CORS) — POST mógł już dotrzeć;
            // zachowujemy dotychczasowe zachowanie i pokazujemy sukces.
            // MailerLite i tak wysyła maila z potwierdzeniem zapisu.
            showSuccess();
          });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plant-quick-filters"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('plant-tabs-nav')) {
    customElements.define(
      'plant-tabs-nav',
      class extends HTMLElement {
        connectedCallback() {
          this.row = this.querySelector('.plant-tabs__row');
          this.more = this.querySelector('.plant-tabs__more');
          if (!this.row || !this.more) return;
          this.update = this.update.bind(this);
          this.row.addEventListener('scroll', this.update, { passive: true });
          this.more.addEventListener('click', () => {
            this.row.scrollBy({ left: this.row.clientWidth * 0.6, behavior: 'smooth' });
          });
          this.resizeObserver = new ResizeObserver(this.update);
          this.resizeObserver.observe(this.row);
          this.update();
        }

        disconnectedCallback() {
          if (this.resizeObserver) this.resizeObserver.disconnect();
        }

        update() {
          const { scrollWidth, clientWidth, scrollLeft } = this.row;
          this.classList.toggle('is-scrollable', scrollWidth > clientWidth + 1);
          this.classList.toggle('is-at-end', scrollLeft + clientWidth >= scrollWidth - 1);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
